export default {
  Modal01: {
    component: 'EnbLogin01',
    active: false
  },
  ItemSelected01: {},
  CheckoutItens01: [],
  ShowCheckout: false,
  ShowSearch01: false,
  SearchTerm01: '',
  LinksTheme01: [
    {
      text: 'Produtos',
      path: '/loja',
      icon: 'StoreIcon01'
    },
    {
      text: 'Carrinho',
      path: '/checkout',
      icon: 'CartShopIcon01'
    },
    {
      text: 'Finalizar Compra',
      path: '/complete',
      icon: 'LikeIcon01'
    },
    {
      text: 'Pedidos',
      path: '/pedidos',
      icon: 'ListIcon01'
    }
  ],
  Produtos01: [
    // {
    //   id: 15249,
    //   code: '',
    //   tipo: 'Simples',
    //   name: 'Camiseta Masculina básica paris casual Estampada T-shirt',
    //   status: true,
    //   preco: 1.99,
    //   oferta: 0.99,
    //   img: [{ id: 2, img: img2 }],
    //   descricao: 'No mundo atual, o desenvolvimento contínuo de distintas formas de atuação causa impacto indireto na reavaliação das diretrizes de desenvolvimento para o futuro',
    //   dateOfertaStart: '',
    //   dateOfertaEnd: '',
    //   categoria: 'Camisetas',
    //   gerEstoque: false,
    //   statusEstoque: 'Em estoque',
    //   estoque: 0,
    //   pendencia: '',
    //   visibilidade: '',
    //   visualizacao: 0,
    //   atributos: [],
    //   estoqueVariavel: [],
    //   dateCreate: '28/07/2024',
    //   caracter: [
    //    { icon: 'LocationIcon', name: '' },
    //    { icon: 'RoomsIcon', name: '' },
    //    { icon: 'ToiletIcon', name: '' },
    //    { icon: 'ParkingIcon', name: '' },
    //    { icon: 'AreaIcon', name: '' }
    //  ],
    // }
  ],
  ResultSearch01: [],
  ResultFilterCateg: [],
  CategSelected: '',
  FilterProdStore: {
    categoria: ''
  },
  ProdutosStore: [],
  SideNave: false
}
